import { RootState } from '..';

export const customerSelector = (state: RootState) => state.customer;

export const customersListSelector = (state: RootState) => state.customer.list;

export const customersPaginationSelector = (state: RootState) => state.customer.pagination;

export const customersOptionsSelector = (state: RootState) => state.customer.options;
